'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('moment');
var _Date = require('../../01.atoms/Date/Date.js');
var LoaderContent = require('../../01.atoms/LoaderContent/LoaderContent.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-list',
    cnLoader = "".concat(CLASSNAME, "__loader"),
    cnTable = "".concat(CLASSNAME, "__table"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCell = "".concat(CLASSNAME, "__cell"),
    cnDate = "".concat(CLASSNAME, "__date"),
    cnCellTitle = "".concat(cnCell, "--title"),
    cnTitle = "".concat(CLASSNAME, "__title");
/**
 * 
 */

var List = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(List, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(List);

  function List(props) {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, List);

    _this = _super.call(this);
    _this.MyList = _this.renderList();
    return _this;
  }
  /**
   * Render a static list
   */


  _rollupPluginBabelHelpers.createClass(List, [{
    key: "renderList",
    value: function renderList(loading) {
      return function (_ref) {
        var items = _ref.items,
            i18n = _ref.i18n;
        return /*#__PURE__*/React__default.createElement("div", {
          className: cnTable
        }, loading && /*#__PURE__*/React__default.createElement(LoaderContent, {
          className: cnLoader,
          contentPlaceholder: true
        }), items.map(function (item, index) {
          return /*#__PURE__*/React__default.createElement(List.Content, {
            key: index,
            item: item,
            i18n: i18n
          });
        }));
      };
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className)
      }, /*#__PURE__*/React__default.createElement(this.MyList, this.props));
    }
  }]);

  return List;
}(React__default.Component);

_rollupPluginBabelHelpers.defineProperty(List, "Content", function (_ref2) {
  var _ref2$i18n = _ref2.i18n,
      i18n = _ref2$i18n === void 0 ? {} : _ref2$i18n,
      item = _ref2.item,
      _ref2$item = _ref2.item;
  _ref2$item = _ref2$item === void 0 ? {} : _ref2$item;
  var date = _ref2$item.date,
      _ref2$item$href = _ref2$item.href,
      href = _ref2$item$href === void 0 ? '#' : _ref2$item$href,
      title = _ref2$item.title,
      children = _ref2.children;
  var format = {
    lastDay: "[".concat(i18n.yesterday, "] HH:mm"),
    sameDay: "[".concat(i18n.today, "] HH:mm"),
    nextDay: "[".concat(i18n.tomorrow, "] HH:mm"),
    lastWeek: 'DD.MM.YYYY, HH:mm',
    nextWeek: 'DD.MM.YYYY, HH:mm',
    sameElse: 'DD.MM.YYYY, HH:mm'
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement("a", {
    className: classNames(cnCell, cnCellTitle),
    href: href
  }, /*#__PURE__*/React__default.createElement("time", {
    className: classNames(cnDate)
  }, /*#__PURE__*/React__default.createElement(_Date.default, {
    input: date,
    calendarFormat: format
  })), /*#__PURE__*/React__default.createElement("span", {
    className: cnTitle
  }, title)), children);
});
List.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Translation object */
  i18n: PropTypes.shape({
    yesterday: PropTypes.string.isRequired,
    today: PropTypes.string.isRequired,
    tomorrow: PropTypes.string.isRequired
  }).isRequired,

  /** Array of list items */
  items: PropTypes.array,

  /** True for mobile styling */
  mobile: PropTypes.bool
};
List.defaultProps = {
  i18n: {},
  items: []
};

module.exports = List;
